import { render, staticRenderFns } from "./BookContent.vue?vue&type=template&id=57a93c0b"
import script from "./BookContent.vue?vue&type=script&lang=js"
export * from "./BookContent.vue?vue&type=script&lang=js"
import style0 from "./BookContent.vue?vue&type=style&index=0&id=57a93c0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports